// hooks
import { useTranslation } from 'react-i18next';
import { useEffect, useMemo, useState } from 'react';

// types
import { WeekDayPickerProps } from './WeekDayPicker.types';
import { DayIndex } from '../../RecurrencePatternBuilder.types';

// components
import ToggleChip from 'components/shared/ToggleChip/ToggleChip';

// styles
import { FlexBox } from './WeekDayPicker.styles';
import { isEqual } from 'lodash';

const WeekDayPicker = ({ daysSelected, onChange }: WeekDayPickerProps) => {
  const { t } = useTranslation('common', { keyPrefix: 'weekday' });

  const [selection, setSelection] = useState(daysSelected);

  const updateSelection = (idx: DayIndex) => {
    const newSelection =
      selection.indexOf(idx) == -1
        ? [...selection, idx]
        : selection.filter((x) => x != idx);

    setSelection(newSelection);
    onChange(newSelection);
  };

  useEffect(() => {
    if (isEqual(daysSelected, selection)) return;

    setSelection(daysSelected);
  }, [daysSelected]);

  const toggleChips = useMemo(() => {
    return [...Array(7).keys()].map((i) => (
      <ToggleChip
        key={i}
        readonly={selection.indexOf(i as DayIndex) != -1}
        disabled={selection.indexOf(i as DayIndex) == -1}
        label={t(i.toString())}
        value={selection.indexOf(i as DayIndex) != -1}
        onClick={() => updateSelection(i as DayIndex)}
      />
    ));
  }, [selection]);

  return <FlexBox>{toggleChips}</FlexBox>;
};

export default WeekDayPicker;
